import httpManager from "@/app/shared/utils/httpManager";

export async function fetchActiveUsers() {
  const url = `/users/`;
  const response = await httpManager.get(url);
  return response.data;
}
